<div class="modal-header border-0">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-4 mt-3"
		>Détail de l'activité</span
	>
	<button
		type="button"
		class="btn-close custom-button-close border border-white rounded-circle bg-white fs-4"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
</div>
<div class="modal-body">
	<div class="row">
		<div class="">
			<div class="row">
				<div class="row mt-4 px-lg-5 px-2">
					<span class="theme-main-color fs-4 col">Informations</span>
					<!-- <a
						[routerLink]="['/gestion/formations', missionRequest?.id]"
						[queryParams]="{ redirected: true }"
						class="btn col-4 theme-main-color-button"
						(click)="bsModalRef.hide()"
						><i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier le suivi</a
					> -->
				</div>
			</div>
			<div class="row my-5 px-lg-5 px-2">
				<div class="col-8">
					<div class="row my-4">
						<div class="col-6">
							<span
								for="intervenant"
								class="theme-main-color fw-bold form-label row my-2"
								>Intervenant
							</span>
							<span class="row my-2" id="intervenant">{{
								activitePrestation?.intervenant?.firstName + ' ' + activitePrestation?.intervenant?.lastName
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="chargeTravail"
								class="theme-main-color fw-bold form-label row my-2"
								>Charge de travail
							</span>
							<span class="row my-2" id="chargeTravail">{{
								activitePrestation?.chargeTravail
							}}%</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="modaliteReunion"
								class="theme-main-color fw-bold form-label row my-2"
								>Modalité réunion
							</span>
							<span class="row my-2" id="modaliteReunion">{{
								activitePrestation?.modaliteReunion?.name
							}}</span>
						</div>
						<div class="col-6">
							<span
								for="tache"
								class="theme-main-color fw-bold form-label row my-2"
								>Type entretien
							</span>
							<span class="row my-2" id="tache">{{
								activitePrestation?.tache?.name
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="description"
								class="theme-main-color fw-bold form-label row my-2"
								>Description</span
							>
							<span class="row my-2" id="description">{{
								activitePrestation?.description 
							}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
